import React, { Component, Fragment, lazy } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
//components
import LazyLoadComponent from 'components/LazyLoadComponent';

const Chat = lazy(() => import('pages/Chat'));
const Report = lazy(() => import('pages/Report'));
const ViewReports = lazy(() => import('pages/ViewReports'));
const CarePlan = lazy(() => import('pages/CarePlan'));
const ReportPdf = lazy(() => import('pages/ReportPdf'));
const WebAssessment = lazy(() => import('pages/WebAssessment'));
const AssessmentList = lazy(() => import('pages/AssessmentList'));
const AssessmentHome = lazy(() => import('pages/AssessmentHome'));

class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isUserLoggedIn: false,
    };
  }

  onSSOSuccess = () => {
    this.setState({ isUserLoggedIn: true, initiateSSO: false });
  };

  onSSOError = () => {
    this.setState({ initiateSSO: true });
  };

  shouldComponentUpdate(nextPros, nextState) {
    if (
      nextPros.initiateSSO === nextState.initiateSSO &&
      nextPros.isUserLoggedIn === nextState.isUserLoggedIn
    )
      return false;
    else return true;
  }
  render() {
    return (
      <Fragment>
        <Router>
          <Switch>
            <Route path="/" exact component={() => <Redirect to={'/assessment/home'} />} />
            <Route
              path="/assessment/home"
              exact
              component={LazyLoadComponent(props => (
                <AssessmentHome {...props} />
              ))}
            />
            <Route
              path="/assessment/list"
              exact
              component={LazyLoadComponent(props => (
                <AssessmentList {...props} />
              ))}
            />
            <Route
              path="/assessment/c/:tinyUrlCode"
              exact
              component={LazyLoadComponent(props => (
                <ViewReports {...props} />
              ))}
            />
            <Route
              path="/assessment/:assessmentName/chat"
              exact
              component={LazyLoadComponent(props => (
                <Chat {...props} />
              ))}
            />

            <Route
              path="/assessment/:assessmentName/report"
              exact
              component={LazyLoadComponent(props => (
                <Report {...props} />
              ))}
            />

            <Route
              path="/assessment/:assessmentName/report-pdf"
              exact
              component={LazyLoadComponent(props => (
                <ReportPdf {...props} />
              ))}
            />

            <Route
              path="/assessment/:assessmentName/care/:caseId"
              exact
              component={LazyLoadComponent(props => (
                <CarePlan {...props} />
              ))}
            />

            {/**
             * To Support old /apps/assessment/* routes, they will be redirected to
             * new routes /assessment/*
             */}
            <Route
              path="/apps/assessment/:assessmentName"
              exact
              component={() => <Redirect to={`/assessment/covid-19/chat`} />}
            />
            <Route
              path="/assessment/:assessmentName/web/:assessmentRef"
              exact
              component={LazyLoadComponent(props => (
                <WebAssessment {...props} />
              ))}
            />
            <Route
              path="/assessment/:assessmentName/web"
              exact
              component={LazyLoadComponent(props => (
                <WebAssessment {...props} />
              ))}
            />
          </Switch>
        </Router>
      </Fragment>
    );
  }
}

export default Routes;
